import { useEffect, useState } from "react";
import { Button, Input, Modal, Pagination, Space, Table } from "antd";
import toast from "react-hot-toast";
import { FooterFilterMobile, LoaderCustom } from "../../components";
import { useGetVoucherApi } from "../../hooks/voucher/useGetVoucherApi";
import { useDeleteVoucherApi } from "../../hooks/voucher/useDeleteVoucherApi";
import { useCreateVoucherApi } from "../../hooks/voucher/useCreateVoucherApi";
import { useUpdateVoucherApi } from "../../hooks/voucher/useUpdateVoucherApi";
import { HiPencilAlt } from "react-icons/hi";
import { MdDelete } from "react-icons/md";

const VoucherManagePage = () => {
  // state
  const [listTypeTransaction, setListTypeTransaction] = useState<any>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenUpdate, setIsModalOpenUpdate] = useState(false);

  // state info create
  const [infoVoucher, setInfoVoucher] = useState<any>({
    chinhanh: "",
    menhgia: 0,
    soluong: 0,
    expireDate: 0,
    category: "",
  });

  const [infoUpdateVoucher, setInfoUpdateVoucher] = useState<any>({
    eventPointNew: "",
    eventPoint: "",
    menhgia: 0,
    soluong: 0,
    expireDate: 0,
    category: "",
    chinhanh: "",
  });

  const [infoUpdate, setInfoUpdate] = useState<any>();

  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(10);

  // api
  const { vouchers } = useGetVoucherApi(page, 10);
  const { mutate: $createNewVoucher, isPending: isPendingCreate } =
    useCreateVoucherApi();
  const { mutate: $updateVoucherApi } = useUpdateVoucherApi();
  const { mutate: $deleteVoucher } = useDeleteVoucherApi();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    $createNewVoucher(infoVoucher, {
      onSuccess: () => {
        toast.success("Create new Type Transaction success");
        setIsModalOpen(false);
        return;
      },
      onError: () => {
        toast.error("Create new Type Transaction failure");
        setIsModalOpen(false);
        return;
      },
    });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleOkUpdate = async () => {
    $updateVoucherApi(
      {
        // type,
        ...infoUpdateVoucher,
        eventPoint: infoUpdate?.event_POINT,
        soluong: 1,
        expireDate: +infoUpdateVoucher?.expireDate,
      },
      {
        onSuccess: () => {
          toast.success("Update Type Transaction success");
          setIsModalOpenUpdate(false);
          return;
        },
        onError: () => {
          toast.error("Update Type Transaction failure");
          setIsModalOpenUpdate(false);
          return;
        },
      }
    );
  };

  const handleDelete = async (id: any) => {
    $deleteVoucher(id, {
      onSuccess: () => {
        toast.success("Delete Voucher Successfully");
        setIsModalOpenUpdate(false);
        return;
      },
      onError: () => {
        toast.error("Delete Voucher Failure");
        setIsModalOpenUpdate(false);
        return;
      },
    });
  };

  const handleCancelUpdate = () => {
    setIsModalOpenUpdate(false);
  };

  useEffect(() => {
    if (vouchers) {
      const convertData = vouchers?.data?.vouchers?.map(
        (item: any, index: number) => {
          return {
            id: item?.id,
            key: index,
            category: item?.category,
            expire_Date: item?.expire_Date,
            event_POINT: item?.event_POINT,
            price: item?.price,
            event_HDD: item?.event_HDD,
          };
        }
      );
      setListTypeTransaction(convertData);
      setTotalPage(vouchers?.data?.totalPages);
    }
  }, [vouchers]);

  const columns = [
    {
      title: "category",
      dataIndex: "category",
      key: "category",
    },
    {
      title: "event_POINT",
      dataIndex: "event_POINT",
      key: "event_POINT",
    },
    {
      title: "expire_Date",
      dataIndex: "expire_Date",
      key: "expire_Date",
    },
    {
      title: "price",
      dataIndex: "price",
      key: "price",
    },
    {
      title: "event_HDD",
      dataIndex: "event_HDD",
      key: "event_HDD",
    },
    {
      title: "Action",
      dataIndex: "",
      key: "action",
      render: (_: any, record: any) => (
        <Space size="large">
          <div
            className="cursor-pointer hover:underline font-medium bg-blue-500 bg-opacity-20 h-full flex justify-center items-center p-[6px] rounded-md"
            onClick={() => {
              {
                setInfoUpdate(record);
                setInfoUpdateVoucher({
                  eventPoint: record?.event_POINT,
                  menhgia: record?.price,
                  expireDate: record?.expire_Date,
                  category: record?.category,
                  eventPointNew: record?.event_POINT,
                  chinhanh: record?.event_HDD,
                });
                setIsModalOpenUpdate(true);
              }
            }}
          >
            <HiPencilAlt className="xl:text-2xl text-xl text-blue-500 cursor-pointer"></HiPencilAlt>
          </div>
          <span
            className="cursor-pointer hover:underline font-medium bg-red-500 bg-opacity-20 h-full flex justify-center items-center p-[6px] rounded-md"
            onClick={() => {
              {
                handleDelete(record?.event_POINT);
              }
            }}
          >
            <MdDelete className="xl:text-2xl text-xl text-red-500 cursor-pointer" />
          </span>
        </Space>
      ),
    },
  ];

  return (
    <div>
      {/* update */}
      <Modal
        okButtonProps={{ style: { backgroundColor: "black" } }}
        title="Update Voucher"
        open={isModalOpenUpdate}
        onOk={handleOkUpdate}
        onCancel={handleCancelUpdate}
        key={infoUpdate?.event_POINT}
      >
        <div className="flex flex-col gap-4">
          <Input
            onChange={(e) => {
              setInfoUpdateVoucher((init: any) => {
                return {
                  ...init,
                  eventPointNew: e.target.value,
                };
              });
            }}
            defaultValue={infoUpdate?.event_POINT}
            placeholder="Mã voucher (Event Point)"
          />
          <Input
            onChange={(e) => {
              setInfoUpdateVoucher((init: any) => {
                return {
                  ...init,
                  chinhanh: e.target.value,
                };
              });
            }}
            defaultValue={infoUpdate?.event_HDD}
            placeholder="Chi nhánh (Event Hdd)"
          />
          <Input
            onChange={(e) => {
              setInfoUpdateVoucher((init: any) => {
                return {
                  ...init,
                  menhgia: e.target.value,
                };
              });
            }}
            placeholder="Mệnh giá"
            defaultValue={infoUpdate?.price}
            type="number"
          />
          {/* <Input
            onChange={(e) => {
              setInfoUpdateVoucher({ ...infoVoucher, soluong: e.target.value });
            }}
            placeholder="Số lượng"
            defaultValue={infoUpdate?.soluong}
            type="number"
          /> */}
          <Input
            onChange={(e) => {
              setInfoUpdateVoucher((init: any) => {
                return {
                  ...init,
                  expireDate: e.target.value,
                };
              });
            }}
            placeholder="Thời gian hết hạn"
            defaultValue={infoUpdate?.expire_Date}
            type="number"
          />
          <Input
            onChange={(e) => {
              setInfoUpdateVoucher((init: any) => {
                return {
                  ...init,
                  category: e.target.value,
                };
              });
            }}
            placeholder="Danh mục (CHECKIN)"
            defaultValue={infoUpdate?.category}
          />
        </div>
      </Modal>
      {/* create */}
      <Modal
        okButtonProps={{ style: { backgroundColor: "black" } }}
        title="Create New Voucher"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <div className="flex flex-col gap-4">
          <Input
            onChange={(e) => {
              setInfoVoucher({ ...infoVoucher, chinhanh: e.target.value });
            }}
            placeholder="Tên chi nhánh"
          />
          <Input
            onChange={(e) => {
              setInfoVoucher({ ...infoVoucher, menhgia: e.target.value });
            }}
            placeholder="Mệnh giá"
            type="number"
          />
          <Input
            onChange={(e) => {
              setInfoVoucher({ ...infoVoucher, soluong: e.target.value });
            }}
            placeholder="Số lượng"
            type="number"
          />
          <Input
            onChange={(e) => {
              setInfoVoucher({ ...infoVoucher, expireDate: e.target.value });
            }}
            placeholder="Thời gian hết hạn"
            type="number"
          />
          <Input
            onChange={(e) => {
              setInfoVoucher({ ...infoVoucher, category: e.target.value });
            }}
            placeholder="Danh mục (CHECKIN)"
          />
          <div className="flex items-center my-2">
            {isPendingCreate && (
              <span className="font-semibold">Loading...</span>
            )}
          </div>
        </div>
      </Modal>
      <div className="max-lg:px-[12px]">
        <div className="flex max-lg:flex-col lg:items-center max-lg:mt-2 justify-between xl:mb-7 lg:mb-5 mb-4 max-sm:flex-row max-sm:justify-between">
          <span className="uppercase xl:text-xl text-base font-semibold text-gray-600">
            MANAGE VOUCHER
          </span>
          <div>
            <Button
              onClick={showModal}
              color="default"
              variant="solid"
              size="middle"
            >
              <span className=" max-lg:text-sm max-sm:text-xs">
                CREATE VOUCHER
              </span>
            </Button>
          </div>
        </div>
        <Table
          dataSource={listTypeTransaction}
          columns={columns}
          pagination={false}
          className="max-md:hidden"
        ></Table>
        {/* mobile */}
        <div className="md:hidden flex flex-col px-[2px] xl:gap-6 gap-4">
          {listTypeTransaction &&
            listTypeTransaction?.map((item: any, index: number) => {
              return (
                <div
                  key={index}
                  className="flex flex-col w-full bg-white border-[1px] border-gray-200 sm:min-h-[20vh] max-sm:min-h-[20vh]"
                >
                  <div className="w-full sm:h-[10vh] max-sm:h-[8vh] bg-gray-200 flex items-center justify-between sm:p-[12px] p-[10px]">
                    <div className="uppercase font-semibold text-gray-600">
                      {item?.category}
                    </div>
                    <div className="flex items-center gap-4 h-full">
                      <div
                        className="cursor-pointer hover:underline font-medium bg-blue-500 bg-opacity-20 h-full min-w-12 flex justify-center items-center p-[6px] rounded-md"
                        onClick={() => {
                          {
                            setInfoUpdate(item);
                            setInfoUpdateVoucher({
                              eventPoint: item?.event_POINT,
                              menhgia: item?.price,
                              expireDate: item?.expire_Date,
                              category: item?.category,
                              eventPointNew: item?.event_POINT,
                              chinhanh: item?.event_HDD,
                            });
                            setIsModalOpenUpdate(true);
                          }
                        }}
                      >
                        <HiPencilAlt className="text-3xl text-blue-700 cursor-pointer"></HiPencilAlt>
                      </div>
                      <div
                        className="cursor-pointer hover:underline font-medium bg-red-500 bg-opacity-20 h-full min-w-12 flex justify-center items-center p-[6px] rounded-md"
                        onClick={() => {
                          {
                            // setInfoUpdate(record);
                            handleDelete(item?.event_POINT);
                          }
                        }}
                      >
                        <MdDelete className="text-3xl text-red-500 cursor-pointer" />
                      </div>
                    </div>
                  </div>
                  <div className="sm:p-[12px] p-[10px] w-full h-auto flex flex-col sm:gap-5 max-sm:gap-4">
                    <div className="flex items-center sm:gap-6 gap-5">
                      <div className="w-[30%] font-bold text-gray-600">
                        event_POINT:
                      </div>
                      <div className="uppercase text-gray-700 font-bold">
                        {item?.event_POINT}
                      </div>
                    </div>
                    <div className="flex items-center sm:gap-6 gap-5">
                      <div className="w-[30%] font-bold text-gray-600">
                        category:
                      </div>
                      <div className="uppercase text-gray-700">
                        {item?.category}
                      </div>
                    </div>
                    <div className="flex items-center sm:gap-6 gap-5">
                      <div className="w-[30%] font-bold text-gray-600">
                        event_HDD:
                      </div>
                      <div className="uppercase text-gray-700">
                        {item?.event_HDD}
                      </div>
                    </div>
                    <div className="flex items-center sm:gap-6 gap-5">
                      <div className="w-[30%] font-bold text-gray-600">
                        expire_Date:
                      </div>
                      <div className="uppercase text-gray-700">
                        {item?.expire_Date}
                      </div>
                    </div>
                    <div className="flex items-center sm:gap-6 gap-5">
                      <div className="w-[30%] font-bold text-gray-600">
                        price:
                      </div>
                      <div className="uppercase text-gray-700">
                        {item?.price}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
        <div className="mt-5 max-sm:mt-3 w-full flex items-center justify-end">
          <Pagination
            align="start"
            defaultCurrent={1}
            total={totalPage * 10}
            onChange={(page: any) => {
              setTotalPage(totalPage * 10);
              setPage(page);
            }}
          />
        </div>
      </div>
      <FooterFilterMobile></FooterFilterMobile>
    </div>
  );
};

export default VoucherManagePage;
